import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import TeamMemberResetPasswordModal from '../../components/team-members/TeamMemberResetPasswordModal'
import { sendResetPasswordLink } from '../../state/actions/team_members/index'
import { IMemberSearchObject, IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: RouteComponentProps<any>) => {
  return {
    teamMember: state.teamMember.items[ownProps.match.params.id],
    routeProps: ownProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onResetClick: (teamMember: IMemberSearchObject) => {
      return dispatch(sendResetPasswordLink(teamMember))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMemberResetPasswordModal)



// WEBPACK FOOTER //
// ./src/containers/team-members/TeamMemberResetPasswordModal.ts